import { render, staticRenderFns } from "./AmazonTransparency.vue?vue&type=template&id=6ab20334"
import script from "./AmazonTransparency.vue?vue&type=script&lang=js"
export * from "./AmazonTransparency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports